import { render, staticRenderFns } from "./AuditTrail.vue?vue&type=template&id=3b298442"
import script from "./AuditTrail.vue?vue&type=script&lang=js"
export * from "./AuditTrail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports